/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Expires/Content"
  
}) {
let connectionValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
format: fromHelpers.expiresDisplay,
})
let connectionValueData1 = fromData.useDataFormat({ viewPath,
context: 'connection',
format: fromHelpers.expiresDisplayAlert,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsRed700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700'
        })
let connectionConnectedAtValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'connected_at',
format: fromHelpers.formatDate,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={connectionValueData1 ? dtColorsRed700 : dtColorsNeutral700}
 data="connection"
 format="helpers.js expiresDisplay"
 text={connectionValueData}
 data="connection"
 format="helpers.js expiresDisplayAlert"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 size="small"
 data="connection.connected_at"
 format="helpers.js formatDate"
 text={connectionConnectedAtValueData}
/>
{children}
</React.Fragment>)
}